import PropTypes from 'prop-types';
import Icon from '../Icon';
import './index.css';

export default function FeatureIcon(props) {
    const { label, icon, path } = props;

    return (
        <div className="col feature-icon-container p-m">
            <div className="row justify-center">
                {icon ? <Icon name={icon} size="xl" color="primary" /> : null}
                {path ? (
                    <img src={path} alt={label} style={{ width: '35px', height: '35px' }} />
                ) : null}
            </div>
            <div className="row mt-s justify-center">{label}</div>
        </div>
    );
}

FeatureIcon.propTypes = {
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    path: PropTypes.string
};
